// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Link from "@mui/material/Link";
//import FavoriteIcon from "@mui/icons-material/Favorite";

import MDBox from "components/atoms/MDBox";
import MDTypography from "components/atoms/MDTypography";

import typography from "assets/theme/base/typography";

function Footer({ company, links, color }) {
  const { href, name } = company;
  const { size } = typography;

  const renderLinks = () =>
    links.map((link) => (
      <MDBox key={link.name} component="li" px={2} lineHeight={1}>
        <Link href={link.href} target="_blank">
          <MDTypography variant="button" fontWeight="regular" color={color}>
            {link.name}
          </MDTypography>
        </Link>
      </MDBox>
    ));

  return (
    <MDBox
      width="100%"
      display="flex"
      flexDirection={{ xs: "column", lg: "row" }}
      justifyContent="space-between"
      alignItems="center"
      px={1.5}
    >
      <MDBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
        color={color}
        fontSize={size.sm}
        px={1.5}
      >
        &copy; {new Date().getFullYear()}, powered by
        <Link href={href} target="_blank">
          <MDTypography variant="button" fontWeight="medium" color={color}>
            &nbsp;{name}&nbsp;
          </MDTypography>
        </Link>
      </MDBox>
      <MDBox
        sx={({ breakpoints }) => ({
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          listStyle: "none",
          mt: 3,
          mb: 0,
          p: 0,

          [breakpoints.up("lg")]: {
            mt: 0,
          },
        })}
      >
        {renderLinks()}
      </MDBox>
    </MDBox>
  );
}

// Setting default values for the props of Footer
Footer.defaultProps = {
  company: { href: "http://www.vixel.com.sg/", name: "ViXEL" },
  links: [
    { href: "", name: "Cusum" },
    { href: "", name: "Project Team" },
  ],
  light: false,
};

// Typechecking props for the Footer
Footer.propTypes = {
  company: PropTypes.objectOf(PropTypes.string),
  links: PropTypes.arrayOf(PropTypes.object),
  color: PropTypes.oneOf(["text", "white", "dark"]),
};

export default Footer;
